import { useCallback, useState } from "react"

import { type UnitSystem } from "@/lib/unit-convert"

const STORAGE_KEY = "recipe-unit-system"

// Remembers the reader's preferred measurement system across recipes.
export function useUnitSystem(): [UnitSystem, (system: UnitSystem) => void] {
  const [system, setSystemState] = useState<UnitSystem>(() => {
    if (typeof localStorage === "undefined") return "metric"
    const stored = localStorage.getItem(STORAGE_KEY)
    return stored === "imperial" || stored === "metric" ? stored : "metric"
  })

  const setSystem = useCallback((next: UnitSystem) => {
    setSystemState(next)
    try {
      localStorage.setItem(STORAGE_KEY, next)
    } catch {
      // ignore storage failures (e.g. private mode)
    }
  }, [])

  return [system, setSystem]
}
